import Location from '../models/Location';

export class StringFormatService {
    static format(str: string, args: string[]) {
        return str.replace(/{(\d+)}/g, (match, index) => typeof args[index] !== 'undefined' ? args[index] : match);
    }

    static capitalise(input: string) {
        return input && input.toLowerCase().replace(/(\b[a-z](?!\s))/g, a => a.toUpperCase()) || '';
    }

    static decodeHtmlEntity(str: string) {
        str = str.replace(/&amp;/g, '&');
        return str.replace(/&#(\d+);/g, (_match, dec) => String.fromCharCode(dec));
    }

    static getAddressString(address: Location): string {
        if (!address) {
            return '';
        }

        let addressString = '';
        if (address.formattedAddress) {
            addressString = address.formattedAddress;
        } else {
            const addItem = (addressStr: string, item: string) => addressStr && `${addressStr}, ${item}` || item;

            if (address.route) {
                addressString = address.route;
            }

            if (address.locality) {
                addressString = addItem(addressString, address.locality);
            }

            if (address.administrativeAreaLevel1Short) {
                addressString = addItem(addressString, address.administrativeAreaLevel1Short);
            }

            if (address.postalCode) {
                addressString = addItem(addressString, address.postalCode);
            }
        }

        return StringFormatService.decodeHtmlEntity(addressString);
    }

}



// WEBPACK FOOTER //
// ./src/services/StringFormatService.ts